import { ProxyLang } from "./Localization/locDef"

// da sincronizzare con public/config.js
type AppConfigType = {
    proxyUrl: string,
    DEFAULT_PROXY_LANGUAGE?: ProxyLang,
    LIVEAVATAR_API_KEY: string,
    LIVEAVATAR_MODE?: string,
    AZURE_SPEECH_KEY?: string,
    AZURE_SPEECH_REGION?: string,
    HEYGEN_API_KEY: string,
    DEFAULT_AVATAR_ID: string,
    DEFAULT_AVATAR_ID_LANDSCAPE: string,
    DEFAULT_AVATAR_ID_PORTRAIT: string,
    DEFAULT_VOICE_ID: string,
    idleTimeoutSeconds: number,
    voices: {[key in ProxyLang]: {lang: string, voice: string}},
}

export const AppConfig = (window as any).appConfig as AppConfigType